import React from "react";
import Avatar from "@material-ui/core/Avatar";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { Formik } from "formik";
import { usuarioForgetPassword } from "../../services/UsuarioService";
import { Captcha } from "primereact/captcha";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import LockOpenOutlinedIcon from "@material-ui/icons/LockOpenOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Loading } from "../Loading";
import { ShowMessageBox } from "../ShowMessageBox";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Copyright © "}
            <Link color="inherit" href="https://zaiac.com.br">
                Zaiac Tecnologia Ltda ME
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

let msg = "";
let severity = "error";

function Esquecisenha() {
    const classes = useStyles();
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [openLoading, setOpenLoading] = React.useState(false);

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />

            <Loading open={openLoading} />

            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOpenOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Esqueci minha senha
                </Typography>

                <ShowMessageBox
                    open={openSnackBar}
                    setOpen={setOpenSnackBar}
                    severity={severity}
                    msg={msg}
                />

                <Formik
                    initialValues={{
                        username: "",
                        usernamerep: "",
                        recaptcha: "",
                        msg: "",
                    }}
                    validate={(values) => {
                        const errors = {};
                        if (!values.username) {
                            errors.username = "Obrigatório";
                        } else if (!values.usernamerep) {
                            errors.usernamerep = "Obrigatório";
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.username)
                        ) {
                            errors.username = "E-mail invalido";
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                values.usernamerep
                            )
                        ) {
                            errors.username = "E-mail invalido";
                        } else if (values.username !== values.usernamerep) {
                            errors.username = "E-mails são diferentes";
                        } else if (!values.recaptcha) {
                            errors.recaptcha = "Não sou robo";
                        }
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, props, resetForm }) => {
                        setSubmitting(true);
                        setOpenLoading(true);
                        setOpenSnackBar(false);

                        const auth = { usu_email: values.username };
                        try {
                            await usuarioForgetPassword(auth);
                            setSubmitting(false);
                            setOpenLoading(false);
                            msg =
                                "Solicitação de senha concluída com sucesso. Check seu e-mail para ver a senha a ser utilizada";
                            severity = "warning";
                            resetForm({
                                username: "",
                                usernamerep: "",
                                recaptcha: "",
                                msg: "",
                            });
                            setOpenSnackBar(true);
                        } catch (error) {
                            if (error.message === "Request failed with status code 401") {
                                console.log("Error");
                                msg = "Erro de autenticacao";
                                console.log(msg);
                                setOpenSnackBar(true);
                            } else {
                                console.log("Error");
                                msg = error.message;
                                console.log(msg);
                                setOpenSnackBar(true);
                            }
                            setOpenLoading(false);
                        }
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form onSubmit={handleSubmit} className={classes.form}>
                            <TextField
                                value={values.username}
                                name="username"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="username"
                                autoComplete="false"
                                type="text"
                                label="E-Mail"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.username}
                                autoFocus
                            />

                            <TextField
                                value={values.usernamerep}
                                name="usernamerep"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="usernamerep"
                                autoComplete="false"
                                type="text"
                                label="Repetir E-Mail"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.usernamerep}
                            />

                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                type="submit"
                                disabled={!isValid}
                                className={classes.submit}
                            >
                                Solicitar troca
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Captcha
                                        siteKey="6LcFeh0bAAAAAJl80I_ldJXz418gbnu9hYWspDm0"
                                        language="pt"
                                        onResponse={(response) => {
                                            setFieldValue("recaptcha", response);
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Link href="/" variant="body2">
                                    Ir para a tela de login
                                </Link>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default Esquecisenha;
